import { Route } from '@angular/router';
import { LoginGuard, PermissionGuard } from '@simac/ui';

export const FieldRetourMoveAssetRoute: Route = {
  path: 'field-retour/move-asset',
  children: [
    {
      path: '',
      loadComponent: () => import('./pages/field-retour.component').then((m) => m.FieldRetourMoveAssetComponent),
    },
  ],
  canActivate: [LoginGuard, PermissionGuard],
};
